import React from 'react';

import * as constants from 'utils/constants';

import Dropdown, { ComponentProps as DropdownProps } from '../../Dropdown';
import Input, { ComponentProps as InputProps } from '../../Input';
import TextArea, { ComponentProps as TextAreaProps } from '../../TextArea';
import * as Styled from './styled';

export type ComponentProps = {
  /** Name of the field for AddressData information */
  fieldName: string;
  fullAddressProps?: Partial<TextAreaProps>;
  suburbProps?: Partial<InputProps>;
  postCodeProps?: Partial<InputProps>;
  stateProps?: Partial<DropdownProps>;
};

const Details: React.FC<ComponentProps> = ({
  fieldName,
  fullAddressProps,
  suburbProps,
  postCodeProps,
  stateProps
}) => {
  return (
    <Styled.Wrapper>
      <Styled.InputContainer>
        <TextArea
          name={`${fieldName}.fullDetails.fullAddress`}
          mode={'Input'}
          label='Street address'
          hint='Please include unit number if needed'
          {...fullAddressProps}
        />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Input name={`${fieldName}.fullDetails.suburb`} label='Suburb/Town' {...suburbProps} />
      </Styled.InputContainer>
      <Styled.InputContainer>
        {stateProps?.options?.length === 0 ? (
          <Input name={`${fieldName}.fullDetails.state`} label='State/Territory' {...stateProps} />
        ) : (
          <Dropdown
            name={`${fieldName}.fullDetails.state`}
            label='State/Territory'
            options={constants.stateOptions}
            placeholder='Select'
            {...stateProps}
          />
        )}
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Input
          type='tel'
          name={`${fieldName}.fullDetails.postCode`}
          label='Postcode'
          maskingOptions={{ mask: '9999' }}
          {...postCodeProps}
        />
      </Styled.InputContainer>
    </Styled.Wrapper>
  );
};

export default Details;
